import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import EventPackageSectionForm from './EventPackageSectionForm'

const EventPackageSectionCreate: React.FC = () => (
  <SectionWrapper title={'resources.eventPackageSections.createPackage'}>
    <Create>
      <EventPackageSectionForm />
    </Create>
  </SectionWrapper>
)

export default EventPackageSectionCreate
